import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SITE } from '../data/site';
import { Seo } from '../lib/seo';
import { Reveal } from '../components/motion';

export default function NotFound() {
  return (
    <div className="spotlight-dark grain text-white min-h-[70vh] flex items-center" data-testid="page-404">
      <Seo
        title="Page Not Found (404) | ToxGlobal Analytics"
        description="The page you requested could not be found. Explore ToxGlobal Analytics equipment categories, services, or contact the team."
        path="/404"
      />
      <div className="container-x py-24 max-w-3xl">
        <Reveal>
          <p className="eyebrow text-signal mb-4">Error 404</p>
          <h1 className="display text-4xl sm:text-6xl">Signal lost on this page.</h1>
          <p className="mt-5 text-slate-300 leading-relaxed max-w-xl">
            The page you requested doesn't exist or has moved. Try the equipment catalog, or send your requirement directly —
            it reaches a human either way.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/equipment" className="btn-light" data-testid="404-equipment-link">Browse Equipment</Link>
            <Link to="/contact" className="btn-outline-light" data-testid="404-contact-link">Request a Quote <ArrowRight size={15} /></Link>
          </div>
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
            {SITE.phone} · {SITE.email}
          </p>
        </Reveal>
      </div>
    </div>
  );
}
